import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Form, Button, Row, Col } from 'react-bootstrap'
import Message from '../components/Message'
import Loader from '../components/Loader'
import { resetPassword } from '../actions/userActions'
import SEO from '../components/SEO'

function ChangePasswordScreen() {

    const { id } = useParams()

    const dispatch = useDispatch()

    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [message, setMessage] = useState('')

    const resetPasswordState = useSelector(state => state.userResetPassword)
    const { updating, error, success } = resetPasswordState

    useEffect(() => {
        if (success) {
            setMessage('')
            setPassword('')
            setConfirmPassword('')
        }
    },[dispatch])

    const submitHandler = (e) => {
        e.preventDefault()

        if (password != confirmPassword){
            setMessage('Passwords do not match')
        } else {
            dispatch(resetPassword(id, password))
        }
    }

    return (
        <>
            <SEO 
                title="Change Password - PCRAssist"
                description="Change your PCRAssist account password. Set a new secure password to protect your account."
                canonicalUrl="/reset"
            />
            <div>
                <Row>
                    <Col md={{ offset: 3, span: 6}}>
                        <h1>Reset password</h1>

                        {message && <Message variant='danger'>{message}</Message>}
                        {error && <Message variant='danger'>{error}</Message>}
                        {success && <Message variant='success'>Password successfully updated</Message>}
                        {updating && <Loader/>}

                        <Form onSubmit={(e) => submitHandler(e)}>
                            <Form.Group controlId='password'>
                                <Form.Label>Password</Form.Label>
                                <Form.Control
                                    required
                                    minLength={8}
                                    type='password'
                                    placeholder='Enter password (min. 8 characters)'
                                    value={password}
                                    onChange={(e)=> setPassword(e.target.value)}
                                >                
                                </Form.Control>
                            </Form.Group>
                            <Form.Group controlId='passwordConfirm'>
                                <Form.Label>Confirm Password</Form.Label>
                                <Form.Control
                                    required
                                    minLength={8}
                                    type='password'
                                    placeholder='Confirm Password'
                                    value={confirmPassword}
                                    onChange={(e)=> setConfirmPassword(e.target.value)}
                                >                
                                </Form.Control>
                            </Form.Group>
                            <br/>
                            <Button type='submit' variant='primary'>Submit</Button>
                        </Form>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default ChangePasswordScreen